import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./LockLogin.html';
import styles from './LockLogin-hashed.scss';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import AuthComponentUtils from '../common/AuthComponentUtils';
import appFeatures from 'effective-features!';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

// VARS
var hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT

export default {
    template: hashedTemplate,
    controller: ['MSFEnvironmentsNameLookup', 'app4HostName', 'MSFForgotPasswordLinkPath', 'MSFForgotUsernameLinkPath', '$scope', '$q', '$state', 'state_plugin_config', 'oAuth', '$window', 'ModalService', '$rootScope', function (MSFEnvironmentsNameLookup, app4HostName, MSFForgotPasswordLinkPath, MSFForgotUsernameLinkPath, $scope, $q, $state, STATE_PLUGIN_CONFIG, oAuth, $window, ModalService, $rootScope) {
        // VARS
        $scope.forgotPassLink = 'https://' + app4HostName[MSFEnvironmentsNameLookup[$window.location.hostname]] + MSFForgotPasswordLinkPath;
        $scope.forgotUserNameLink = 'https://' + app4HostName[MSFEnvironmentsNameLookup[$window.location.hostname]] + MSFForgotUsernameLinkPath;
        console.log($window.location.hostname);
        console.log(MSFEnvironmentsNameLookup[$window.location.hostname]);
        var authenticationService = AuthenticationService(oAuth);
        var $ctrl = Object.create(BaseCtrl);
        console.log('From Locklogin - index.js Rootscope value for AppDn is ' + $rootScope.appDn);
        $ctrl.init = function () {};

        $ctrl.loginError = ''; // errors
        $ctrl.isLoginReqInProgress = false; // animation
        $ctrl.isLoginWithGoogleReqInProgress = false; // animation

        // Default model attr required by gw-pl-inline-ctrl-group directive
        $ctrl.input = { aspects: {} };

        // METHODS
        var setCtrlParam = AuthComponentUtils.setCtrlParam($ctrl, $scope);

        function setloginError(value) {
            setCtrlParam('loginError', value);
        }

        $ctrl.loginWithGoogle = function () {
            setloginError(''); // reset errors
            setCtrlParam('isLoginWithGoogleReqInProgress', true); // animation

            authenticationService.loginWithGoogle().then(function (res) {
                setCtrlParam('isLoginWithGoogleReqInProgress', false); // animation
                return res;
            }).catch(function () {
                setCtrlParam('isLoginWithGoogleReqInProgress', false); // animation
                // something went wrong
                setloginError('invalidAttempt');
            });
        };

        $ctrl.login = function () {
            setloginError(''); // reset errors

            if (!$ctrl.username || !$ctrl.password) {
                // check if empty
                setloginError('fieldEmpty');
                return;
            }

            setCtrlParam('isLoginReqInProgress', true); // animation

            authenticationService.login({
                username: $ctrl.username,
                password: $ctrl.password
            }).then(function () {
                // logged in
                setCtrlParam('isLoginReqInProgress', false); // animation
                // reset errors
                setloginError('');
                // redirect user to home view
                $state.go(STATE_PLUGIN_CONFIG.home);
                // all is well ...reset
                $rootScope.invalidUser = false;
            }, function (err) {
                setCtrlParam('isLoginReqInProgress', false); // animation
                // we got an error during initial login.
                // check if the error is undefined in angular...could be server is dn.
                if (err === undefined) {
                    $rootScope.appDn = true;
                } else {
                    $rootScope.appDn = false;
                }
                if (!err || !err.error) {
                    // Fix for defect 0455 to show Portal down message if PC is down.
                    if ($rootScope.appDn) {
                        ModalService.showError('', 'PortalDown.Message');
                    } else {
                        // something went wrong or this is an Invalid login issue

                        //  if (err.baseError !== undefined){
                        //  if (err.baseError.error.code===-32501){
                        $rootScope.invalidUser = true;
                        setloginError('invalidAttempt');
                        // }
                        // }
                    }
                    return;
                }

                switch (err.error) {
                    case authenticationService.ERRORS.auth.login_failure: // credentials are wrong
                    case authenticationService.ERRORS.tokens.notLoggedIn:
                        // tokens check problem
                        setloginError('fieldsIncorrect');
                        break;
                    case authenticationService.ERRORS.auth.account_locked:
                        {
                            // account is locked
                            setloginError('accountLocked');
                            break;
                        }
                    default:
                        setloginError('invalidAttempt');
                        break;
                }
            });
        };

        $ctrl.forgotPassword = function () {
            $state.go('authForgotPassword');
        };

        $ctrl.signUp = function () {
            $state.go('authSignUp');
        };

        $ctrl.isSignUpAllowed = function () {
            return appFeatures.auth && appFeatures.auth.signUpAllowed;
        };

        $ctrl.forgotPasswordEnabled = function () {
            return appFeatures.auth && appFeatures.auth.forgotPasswordAllowed;
        };

        $ctrl.socialLoginEnabled = function () {
            return appFeatures.auth && appFeatures.auth.socialLoginAllowed;
        };

        console.log('calling create scope ...');
        return $ctrl.create($scope);
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/LockLogin/index.js
// module id = 1330
// module chunks = 0